import { render, staticRenderFns } from "./ViewTestQuestions.vue?vue&type=template&id=50c5356a&scoped=true"
import script from "./ViewTestQuestions.vue?vue&type=script&lang=js"
export * from "./ViewTestQuestions.vue?vue&type=script&lang=js"
import style0 from "./ViewTestQuestions.vue?vue&type=style&index=0&id=50c5356a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5356a",
  null
  
)

export default component.exports